import axios from 'axios';

import { HTTP_HEADER } from '@/api/httpHeaders.model.ts';
import { getCsrfToken } from '@/api/utils/getCsrfTokenRequest.util.ts';
import { CONFIG } from '@/config/config.ts';

const START_PAGE = '/';

// The backend answers 200 and names the next address in Location instead of redirecting: XHR would
// follow a redirect on to the identity provider and stop at CORS. That address ends the SSO session
// too, which would otherwise sign the person straight back in.
const nextAddress = async (): Promise<string> => {
  try {
    const { headers } = await axios.post(`${CONFIG.HOST}/logout`, null, {
      headers: { [HTTP_HEADER['X-CSRF-Token']]: await getCsrfToken() },
      withCredentials: true,
    });
    return typeof headers.location === 'string' ? headers.location : START_PAGE;
  } catch {
    // Most likely a 403: the session ran out before the click, taking its CSRF token along.
    // Without a session, the start page goes on to sign in by itself.
    return START_PAGE;
  }
};

export const signOut = async (): Promise<void> => {
  window.location.assign(await nextAddress());
};
